module.exports = __webpack_public_path__ + "img/icon_traslado.5727f0ea.svg";